import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import domtoimage from "dom-to-image";
import { SchemeModel } from "src/app/model/SchemeModel";
import { ApiUrls } from "src/app/services/ApiUrls";
import jsPDF from "jspdf";

@Component({
  selector: "app-secure-scheme-au",
  templateUrl: "./scheme-au.component.html",
  styleUrls: ["./scheme-au.component.scss"],
})
export class SchemeAUComponent implements OnInit {
  schemeKey: number;
  pageMode: string;
  schemeModel: SchemeModel;
  nonEditable: boolean = false;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  schemeImagesUrl: string;
  unsavedBuildingImages: string[] = [];
  unsavedFloorPlans: string[] = [];
  unsavedLocationPlans: string[] = [];
  isLoading: boolean = false;
  isPrinting: boolean = false;

  lotteryList: { [key: number]: string };
  mpIncomeGroupListLotteryWise: { [key: number]: { [key: number]: string } };
  amenityList: [
    {
      amenitySystemConfigKey: number;
      amenityConfigKey: string;
      amenityConfigValue: string;
      amenityConfigImage: string;
    }
  ];

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.schemeImagesUrl = ApiUrls.schemeImagesUrl;
    this.masterService.initSchemeForm().subscribe((data: any) => {
      if (data.status === "SUCCESS") {
        this.lotteryList = data.lotteryList;
        this.mpIncomeGroupListLotteryWise = data.mpIncomeGroupListLotteryWise;
        this.amenityList = data.amenityList;

        this.route.params.subscribe((params: Params) => {
          this.schemeKey = +params["key"];
          if (this.schemeKey) {
            this.masterService
              .getSchemeBykey(this.schemeKey)
              .subscribe((data: any) => {
                if (data.status === "SUCCESS") {
                  this.schemeModel = data;
                  this.pageMode = "Edit";
                  this.nonEditable = data.nonEditable;
                  this.form.patchValue({
                    lotteryKey: {
                      key: this.schemeModel.lotteryEventId,
                      value:
                        this.schemeModel.lotteryCode +
                        " - " +
                        this.schemeModel.lotteryName,
                    },
                    incomeGroupKey: {
                      key: this.schemeModel.incomeGroupId,
                      value:
                        this.schemeModel.incomeGroupCode +
                        " - " +
                        this.schemeModel.incomeGroupName,
                    },
                    schemeCode: this.schemeModel.schemeCode,
                    schemeName: this.schemeModel.schemeName,
                    emdAmount: this.schemeModel.emdAmount,
                    displaySequence: this.schemeModel.displaySequence,
                    taluka: this.schemeModel.taluka,
                    address: this.schemeModel.address,
                    latitude: this.schemeModel.latitude,
                    longitude: this.schemeModel.longitude,
                    citySurveyNo: this.schemeModel.citySurveyNo,
                    builtupArea: this.schemeModel.builtupArea,
                    builtupAreaUnit: this.schemeModel.builtupAreaUnit,
                    carpetArea: this.schemeModel.carpetArea,
                    carpetAreaUnit: this.schemeModel.carpetAreaUnit,
                    cost: this.schemeModel.cost,
                    isPmay: this.schemeModel.isPmay === "Y" ? true : false,
                    reraRegistrationNo: this.schemeModel.reraRegistrationNo,
                    status: this.schemeModel.schemeStatus,
                  });

                  let selectedAmenities: FormArray = this.form.get(
                    "amenities"
                  ) as FormArray;
                  this.schemeModel.amenities.forEach((rf) => {
                    selectedAmenities.push(new FormControl(rf.key));
                  });
                } else {
                  this.masterService.errorToast(data.errorMessage);
                }
              });
          } else {
            this.pageMode = "Add";
          }
        });
      } else {
        this.errorToast(data.errorMessage, 5 * 1000);
      }
    });
    this.form = new FormGroup({
      lotteryKey: new FormControl(null, [Validators.required]),
      incomeGroupKey: new FormControl(null, [Validators.required]),
      schemeCode: new FormControl(null, [
        Validators.required,
        Validators.maxLength(50),
      ]),
      schemeName: new FormControl(null, [
        Validators.required,
        Validators.maxLength(300),
      ]),
      // emdAmount: new FormControl(null, [
      //   Validators.required,
      //   Validators.min(0),
      // ]),
      displaySequence: new FormControl(null, [
        Validators.required,
        Validators.min(0),
      ]),
      taluka: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      address: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      latitude: new FormControl(null, [Validators.required, Validators.min(0)]),
      longitude: new FormControl(null, [
        Validators.required,
        Validators.min(0),
      ]),
      citySurveyNo: new FormControl(null, [Validators.maxLength(255)]),
      builtupArea: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      builtupAreaUnit: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      carpetArea: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      carpetAreaUnit: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      cost: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      isPmay: new FormControl(null),
      reraRegistrationNo: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      status: new FormControl(null),
      amenities: new FormArray([]),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      if (this.pageMode === "Add") {
        this.save();
      } else {
        this.update();
      }
    } else {
      this.isSubmitDisabled = false;
    }
  }

  async save() {
    this.masterService
      .saveScheme({
        lotteryKey: this.form.value.lotteryKey,
        incomeGroupKey: this.form.value.incomeGroupKey,
        schemeCode: this.form.value.schemeCode,
        schemeName: this.form.value.schemeName,
        emdAmount: this.form.value.emdAmount,
        displaySequence: this.form.value.displaySequence,
        taluka: this.form.value.taluka,
        address: this.form.value.address,
        latitude: this.form.value.latitude,
        longitude: this.form.value.longitude,
        citySurveyNo: this.form.value.citySurveyNo,
        builtupArea: this.form.value.builtupArea,
        builtupAreaUnit: this.form.value.builtupAreaUnit,
        carpetArea: this.form.value.carpetArea,
        carpetAreaUnit: this.form.value.carpetAreaUnit,
        cost: this.form.value.cost,
        isPmay: this.form.value.isPmay ? "Y" : "N",
        reraRegistrationNo: this.form.value.reraRegistrationNo,
        amenities: this.form.value.amenities,
        savedBuildingImages: this.schemeModel.buildingImages,
        savedFloorPlanImages: this.schemeModel.floorPlanImages,
        savedLocationImages: this.schemeModel.locationImages,
        unsavedBuildingImages: this.unsavedBuildingImages,
        unsavedFloorPlans: this.unsavedFloorPlans,
        unsavedLocationPlans: this.unsavedLocationPlans,
      })
      .subscribe(
        (data: any) => {
          if (data.status === "SUCCESS") {
            this.successToast();
            this.router.navigate(["/secure", "master", "scheme", "list"]);
          } else {
            this.isSubmitDisabled = false;
            this.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.isSubmitDisabled = false;
          console.log(error);
          this.errorToast(error.error.errorMessage, 5 * 1000);
        }
      );
  }

  async update() {
    this.masterService
      .updateScheme(this.schemeKey, {
        lotteryKey: this.form.value.lotteryKey,
        incomeGroupKey: this.form.value.incomeGroupKey,
        schemeCode: this.form.value.schemeCode,
        schemeName: this.form.value.schemeName,
        emdAmount: this.form.value.emdAmount,
        displaySequence: this.form.value.displaySequence,
        taluka: this.form.value.taluka,
        address: this.form.value.address,
        latitude: this.form.value.latitude,
        longitude: this.form.value.longitude,
        citySurveyNo: this.form.value.citySurveyNo,
        builtupArea: this.form.value.builtupArea,
        builtupAreaUnit: this.form.value.builtupAreaUnit,
        carpetArea: this.form.value.carpetArea,
        carpetAreaUnit: this.form.value.carpetAreaUnit,
        cost: this.form.value.cost,
        isPmay: this.form.value.isPmay ? "Y" : "N",
        reraRegistrationNo: this.form.value.reraRegistrationNo,
        amenities: this.form.value.amenities,
        savedBuildingImages: this.schemeModel.buildingImages,
        savedFloorPlanImages: this.schemeModel.floorPlanImages,
        savedLocationImages: this.schemeModel.locationImages,
        unsavedBuildingImages: this.unsavedBuildingImages,
        unsavedFloorPlans: this.unsavedFloorPlans,
        unsavedLocationPlans: this.unsavedLocationPlans,
      })
      .subscribe(
        (data: any) => {
          if (data.status === "SUCCESS") {
            this.successToast();
            this.router.navigate(["/secure", "master", "scheme", "list"]);
          } else {
            this.isSubmitDisabled = false;
            this.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.isSubmitDisabled = false;
          console.log(error);
          this.errorToast(error.error.errorMessage, 5 * 1000);
        }
      );
  }

  onBuildingImageSelect(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.unsavedBuildingImages.push(reader.result.toString());
    };
  }

  deleteBuildingImage(type: string, i: number) {
    if (type === "SAVED") {
      this.schemeModel.buildingImages.splice(i, 1);
    } else {
      this.unsavedBuildingImages.splice(i, 1);
    }
  }

  onFloorPlanSelect(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.unsavedFloorPlans.push(reader.result.toString());
    };
  }

  deleteFloorPlan(type: string, i: number) {
    if (type === "SAVED") {
      this.schemeModel.floorPlanImages.splice(i, 1);
    } else {
      this.unsavedFloorPlans.splice(i, 1);
    }
  }

  onLocationPlanSelect(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.unsavedLocationPlans.push(reader.result.toString());
    };
  }

  deleteLocationPlan(type: string, i: number) {
    if (type === "SAVED") {
      this.schemeModel.locationImages.splice(i, 1);
    } else {
      this.unsavedLocationPlans.splice(i, 1);
    }
  }

  showLottery(o1: any, o2: any) {
    console.log(o1, o2);
    if (o1 && o2 && o1.key == o2.key) {
      return o1.value;
    } else {
      return "";
    }
  }

  onCheckboxChange(e: any) {
    const selectedAmenities: FormArray = this.form.get(
      "amenities"
    ) as FormArray;
    if (e.target.checked) {
      selectedAmenities.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      selectedAmenities.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          selectedAmenities.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  print() {
    if (this.schemeModel) {
      this.isLoading = true;
      this.isPrinting = true;
      setTimeout(() => {
        const pdfBlock = document.getElementById("print-wrapper");
        const options = {
          background: "white",
          height: pdfBlock.clientHeight,
          width: pdfBlock.clientWidth,
          quality: 1.5,
          filter: (node: any) => {
            if (node.type === "checkbox") {
              console.log(node.checked);
            }
            console.log("id ---", node.id, node.tagName, node.type, node.value);
            return (
              ["no-print", "loading", "breadcrumb"].indexOf(node.id) < 0 &&
              node.tagName !== "BUTTON" &&
              node.type !== "checkbox"
            );
          },
        };
        console.log(pdfBlock.clientWidth, pdfBlock.clientHeight);

        domtoimage.toPng(pdfBlock, options).then((imgData) => {
          const doc = new jsPDF("p", "px", [options.width, options.height]);
          const imgProps = doc.getImageProperties(imgData);
          const pdfWidth = doc.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

          console.log("-----", pdfWidth, pdfHeight);

          doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
          doc.save(
            this.schemeModel?.schemeCode +
              " - " +
              this.schemeModel?.schemeName +
              ".pdf"
          );
          this.isLoading = false;
          this.isPrinting = false;
        });
      }, 200);
    } else {
      this.masterService.errorToast("Please refresh page.");
    }
  }

  async successToast() {
    await this._snackBar.open("Scheme saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
}
